"use strict";var l=Object.defineProperty;var n=Object.getOwnPropertyDescriptor;var i=(a,s,t,c)=>{for(var r=c>1?void 0:c?n(s,t):s,o=a.length-1,p;o>=0;o--)(p=a[o])&&(r=(c?p(s,t,r):p(r))||r);return c&&r&&l(s,t,r),r};import{html as e,SizedMixin as h}from"@spectrum-web-components/base";import{property as m}from"@spectrum-web-components/base/src/decorators.js";import{CheckboxBase as d}from"./CheckboxBase.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-checkmark75.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-checkmark100.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-checkmark200.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-checkmark300.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-dash75.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-dash100.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-dash200.js";import"@spectrum-web-components/icons-ui/icons/sp-icon-dash300.js";import u from"./checkbox.css.js";import k from"@spectrum-web-components/icon/src/spectrum-icon-checkmark.css.js";import I from"@spectrum-web-components/icon/src/spectrum-icon-dash.css.js";const f={s:e`
        <sp-icon-checkmark75
            id="checkmark"
            class="spectrum-Icon spectrum-UIIcon-Checkmark75"
        ></sp-icon-checkmark75>
    `,m:e`
        <sp-icon-checkmark100
            id="checkmark"
            class="spectrum-Icon spectrum-UIIcon-Checkmark100"
        ></sp-icon-checkmark100>
    `,l:e`
        <sp-icon-checkmark200
            id="checkmark"
            class="spectrum-Icon spectrum-UIIcon-Checkmark200"
        ></sp-icon-checkmark200>
    `,xl:e`
        <sp-icon-checkmark300
            id="checkmark"
            class="spectrum-Icon spectrum-UIIcon-Checkmark300"
        ></sp-icon-checkmark300>
    `},S={s:e`
        <sp-icon-dash75
            id="partialCheckmark"
            class="spectrum-Icon spectrum-UIIcon-Dash75"
        ></sp-icon-dash75>
    `,m:e`
        <sp-icon-dash100
            id="partialCheckmark"
            class="spectrum-Icon spectrum-UIIcon-Dash100"
        ></sp-icon-dash100>
    `,l:e`
        <sp-icon-dash200
            id="partialCheckmark"
            class="spectrum-Icon spectrum-UIIcon-Dash200"
        ></sp-icon-dash200>
    `,xl:e`
        <sp-icon-dash300
            id="partialCheckmark"
            class="spectrum-Icon spectrum-UIIcon-Dash300"
        ></sp-icon-dash300>
    `};export class Checkbox extends h(d,{noDefaultSize:!0}){constructor(){super(...arguments);this.indeterminate=!1;this.invalid=!1;this.emphasized=!1}static get styles(){return[u,k,I]}handleChange(){this.indeterminate=!1,super.handleChange()}render(){return e`
            ${super.render()}
            <span id="box">
                ${f[this.size]}
                ${S[this.size]}
            </span>
            <label id="label" for="input"><slot></slot></label>
        `}updated(t){super.updated(t),t.has("invalid")&&(this.invalid?this.inputElement.setAttribute("aria-invalid","true"):this.inputElement.removeAttribute("aria-invalid")),t.has("indeterminate")&&(this.inputElement.indeterminate=this.indeterminate)}}i([m({type:Boolean,reflect:!0})],Checkbox.prototype,"indeterminate",2),i([m({type:Boolean,reflect:!0})],Checkbox.prototype,"invalid",2),i([m({type:Boolean,reflect:!0})],Checkbox.prototype,"emphasized",2);
//# sourceMappingURL=Checkbox.js.map
